<template>
  <v-card class="asset-type-form">
    <v-card-title v-if="update">Update Type: {{ assetType.name }}</v-card-title>
    <v-card-title v-else>Create a New Asset Type</v-card-title>
    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-text-field
          v-model="assetType.name"
          label="Asset Type Name"
          :rules="typeNameRules"
          required
        ></v-text-field>

        <v-card
          v-for="(metaField, mf) in assetType.metadataDefinitions"
          :key="mf"
          outlined
          class="my-3"
        >
          <v-card-title>{{ metaField.title ? metaField.title : 'New Metadata Item' }}</v-card-title>

          <!-- Meta Form -->
          <v-card-text>
            <v-text-field
              v-model="metaField.title"
              label="Title"
              @change="metaField.name = metaField.title.toLowerCase().replace(' ', '_')"
            ></v-text-field>
            <v-select
              v-model="metaField.type"
              :items="typeValues"
              label="Type"
            ></v-select>
            <v-checkbox
              v-model="metaField.required"
              label="Required"
            ></v-checkbox>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- Add Another -->
            <v-btn
              small
              v-if="mf === assetType.metadataDefinitions.length - 1"
              @click="addMetaFormItem"
            >
              Add Another Item
              <v-icon right>
                mdi-playlist-plus
              </v-icon>
            </v-btn>

            <!-- Remove Item -->
            <v-btn
              v-else-if="assetType.metadataDefinitions[mf].id === undefined"
              small
              color="error"
              @click="assetType.metadataDefinitions.splice(mf, 1)"
            >
            Remove {{ metaField.title }}
              <v-icon right>
                mdi-playlist-remove
              </v-icon>
            </v-btn>
          </v-card-actions>

        </v-card>
      </v-form>
    </v-card-text>
    <v-card-actions
      class="mt-3"
    >
      <v-btn
        color="primary"
        :loading="loading"
        :disabled="loading"
        @click="update ? updateType() : addType()"
      >
        <v-icon left>
          mdi-content-save
        </v-icon>
        {{ update ? "Update" : "Create" }}
      </v-btn>
      <v-btn
        v-if="assetType.metadataDefinitions.length === 0"
        color="secondary"
        @click="addMetaFormItem"
      >
        <v-icon left>
          mdi-playlist-plus
        </v-icon>
        Metadata
      </v-btn>
      <v-btn
        @click="clearAndClose"
      >
        <v-icon left>
          mdi-cancel
        </v-icon>
        Cancel
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'AssetTypeForm',

    computed: {
      ...mapGetters(['adminAssetType'])
    },

    data: () => ({
      update: false,

      // Form handling.
      loading: false,
      valid: true,
      typeNameRules: [
        v => !!v || 'Name is required'
      ],

      // Asset Type Types
      typeValues: [
        'text',
        'number',
        'flag',
        'longText',
        'currency',
        'image'
      ],

      assetType: {
        id: 0,
        name: '',
        metadataDefinitions: []
      }
    }),

    methods: {
      ...mapActions([
        'createAssetTypes',
        'getAssetType',
        'updateAssetType'
      ]),

      addMetaFormItem: function () {
          // Blank metadata entry.
        const metadataBase = {
          name: '',
          required: true,
          title: '',
          type: 'text'
        }

        this.assetType.metadataDefinitions.push(metadataBase)
      },

      clearAndClose: function () {
        // Clear
        this.$refs.form.reset()
        this.assetType.metadataDefinitions = []
        this.loading = false

        // Close
        this.$emit('dialog-close')
      },

      addType: function () {
        // Validate the form
        this.valid = this.$refs.form.validate()

        if (this.valid === true) {
          // Set a throbber.
          this.loading = true
          // Create the asset type.
          this.createAssetTypes(this.assetType).then(() => {
            // Close the dialoge.
            this.clearAndClose()
          })
        }
      },

      updateType: function () {
        // Validate the form
        this.valid = this.$refs.form.validate()

        if (this.valid === true) {
          // Set a throbber.
          this.loading = true
          // Update the asset type.
          this.updateAssetType(this.assetType).then(() => {
            // Success, close the dialogue.
            this.clearAndClose()
          })
        }
      },

      updateCheck: function () {
        // If it's in state then we're updating.
        if (typeof this.adminAssetType.id !== 'undefined') {
          this.update = true

          // Populate the form data.
          this.assetType = this.adminAssetType
        }
      }
    },

    created() {
      this.updateCheck()
    },

    watch: {
      adminAssetType: 'updateCheck'
    }
  }
</script>
